import { render, staticRenderFns } from "./protectLimit.vue?vue&type=template&id=efd60af6&scoped=true"
import script from "./protectLimit.vue?vue&type=script&lang=js"
export * from "./protectLimit.vue?vue&type=script&lang=js"
import style0 from "./protectLimit.vue?vue&type=style&index=0&id=efd60af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd60af6",
  null
  
)

export default component.exports